import { useFormat } from '@ideavivat/vivat-2';

const NOW = `${useFormat.date().dayjs.format('YYYY-MM-DD HH:mm::ss')}`;

const baseConfig = {
  hasRan: false,
  login: {
    features: {
      loginEnable: { value: false, label: 'อนุญาตให้ Login', description: '* User สามารถ Login เข้าระบบ (หรือกรอก Code)' },
      loginEnableCountdown: { value: false, label: 'แสดงเวลานับถอยหลัง', description: '' },
    },
    textConfigs: {
      loginTextCountdown: {
        value: '', label: 'เวลาที่อนุญาตให้ Login', description: 'ถ้าหากไม่ระบุ, จะต้องมี Admin คอยเปิดให้ Login', type: 'date-time',
      },
      loginTextType: {
        value: 'PIN', label: 'วิธีการ Login', description: '', type: 'select', list: ['PIN', 'EMAIL'], display: ['Passcode', 'Email'],
      },
      loginTextRestrict: {
        value: 'AUTO_KICK', label: 'Login Restrict', description: 'ความรัดกุมของการเข้างาน', type: 'select', list: ['DUPLICATED', 'AUTO_KICK', 'SINGLE'], display: ['อนุญาตให้เข้าพร้อมกัน', 'เตะออกอัตโนมัติ', 'เข้าได้เพียงเครื่องเดียว'],
      },
      loginTextPinPlaceholder: {
        value: '', label: 'PIN Placeholder', description: 'ค่าเริ่มต้น: Code', type: '',
      },
      loginTextEnterPinButton: {
        value: '', label: 'Enter PIN Button', description: 'ค่าเริ่มต้น: Confirm Code', type: '',
      },
      loginTextWelcome: {
        value: '<span class="text-2xl">Welcome to</span>', label: 'ข้อความต้อนรับ', description: '* เช่น Welcome to', type: 'markdown',
      },
      loginTextEvent: {
        value: '<span class="text-4xl font-bold">ชื่องาน</span>', label: 'ชื่องานในหน้าต้อนรับ', description: '* ชื่องาน', type: 'markdown',
      },
      loginTextPinSuccessMessage: {
        value: '', label: 'ข้อความแสดงหลังจากกรอก Pin สำเร็จ', description: '', type: 'markdown',
      },
      loginTextPinErrorMessage: {
        value: '', label: 'ข้อความแสดงหลังจากกรอก Pin ไม่สำเร็จ', description: '', type: 'markdown',
      },
    },
    images: {
      loginToEventImage: { value: '', label: 'อัปโหลด รูปภาพแสดงหน้ากรอกโค๊ด / Login', description: 'ภาพตัวอย่าง รูปภาพแสดงหน้ากรอกโค๊ด / Login' },
    },
  },
  register: {
    features: {
      registerEnable: { value: false, label: 'อนุญาตให้สมัครสมาชิก', description: '' },
      registerEnableRegistrationGroup: { value: false, label: 'Field Registration Group', description: 'เปิดให้กรอก Registration Group' },
    },
    textConfigs: {
      registerTextDescriptionTH: {
        value: '', label: 'ข้อความอธิบายการสมัคร (ไทย)', description: '', type: 'markdown',
      },
      registerTextDescriptionEN: {
        value: '', label: 'ข้อความอธิบายการสมัคร (Eng)', description: '', type: 'markdown',
      },
      registerTextPDPATH: {
        value: '', label: 'PDPA', description: '', type: 'markdown',
      },
      registerTextPDPAEN: {
        value: '', label: 'PDPA (Eng)', description: '', type: 'markdown',
      },
      registerTextConfirmationTH: {
        value: '', label: 'ข้อความยืนยันการสมัคร (Modal - TH)', description: 'ถ้าหากไม่ระบุ จะใช้ค่าเริ่มต้นของระบบ', type: 'markdown',
      },
      registerTextConfirmationEN: {
        value: '', label: 'ข้อความยืนยันการสมัคร (Modal - EN)', description: 'ถ้าหากไม่ระบุ จะใช้ค่าเริ่มต้นของระบบ', type: 'markdown',
      },
    },
    images: {
      registerLogoImage: { value: '', label: 'อัปโหลดภาพยืนยันการสมัคร', description: 'ภาพตัวอย่าง' },
      registerBackdropImage: { value: '', label: 'อัปโหลด Banner (PC)', description: 'ภาพตัวอย่าง (Banner PC)' },
      registerBackdropImageMobile: { value: '', label: 'อัปโหลด Banner (Mobile)', description: 'ภาพตัวอย่าง (Banner Mobile)' },
    },
  },
  website: {
    features: {
      websiteEnableNavHome: { value: false, label: 'เมนู Home', description: '* แสดงเมนู Home บน Navigation bar' },
      websiteEnableNavOverview: { value: false, label: 'เมนู Overview', description: '* แสดงเมนู Overview บน Navigation bar' },
      websiteEnableNavRegister: { value: false, label: 'เมนู Register', description: '* แสดงเมนู Live บน Navigation bar' },
      websiteEnableNavContact: { value: false, label: 'เมนู Contact', description: '* แสดงเมนู Contact บน Navigation bar' },
      websiteEnableNavAgenda: { value: false, label: 'เมนู Agenda', description: '* แสดงเมนู Agenda บน Navigation bar' },
      websiteEnableNavSpeaker: { value: false, label: 'เมนู Speaker', description: '* แสดงเมนู Speaker บน Navigation bar' },
      websiteEnableNavLive: { value: false, label: 'เมนู Live', description: '* แสดงเมนู Live บน Navigation bar' },
      websiteEnableNavDownload: { value: false, label: 'เมนู Download', description: '* แสดงเมนู Download บน Navigation bar' },
      websiteEnableNavSponsor: { value: false, label: 'เมนู Sponsor', description: '* แสดงเมนู Sponsor บน Navigation bar' },
      websiteEnableNavLanguage: { value: false, label: 'เมนู เปลี่ยนภาษา', description: '* แสดงเมนู เปลี่ยนภาษา บน Navigation bar' },
      websiteEnableFooterInfo: { value: false, label: 'แสดงข้อมูล Footer', description: 'ie. รูป CONNEX, รายละเอียดการติดต่อ' },
      websiteEnableFooterUrl: { value: false, label: 'แสดงข้อมูล Footer เพิ่มเติม', description: 'ie. Facebook, Youtube, Website' },
    },
    textConfigs: {
      websiteTextSponsorTextEN: { value: '', label: 'ข้อความเมนู Sponsor (อังกฤษ)', description: 'Sponsor' },
      websiteTextSponsorTextTH: { value: '', label: 'ข้อความเมนู Sponsor (ไทย)', description: 'Sponsor' },
    },
    images: {
      websiteLogoImage: { value: '', label: 'อัปโหลด Logo', description: 'ภาพตัวอย่าง' },
    },
  },
  colors: [
    { key: 'primary', colorCode: '#19aaf8' },
    { key: 'secondary', colorCode: '#007ad0' },
  ],
  landing: {
    features: {
      landingEnablePage: { value: false, label: 'เปิดให้เข้า Landing Page' },
      landingEnableLiveNowBar: { value: false, label: 'Live Now Badge', description: '* แถบสีแดง ๆ บนสุดของเว็บไซต์' },
      landingEnableCountdown: { value: false, label: 'แสดง Countdown', description: '' },
      landingEnableRenderAsHTML: { value: false, label: 'แสดงผลด้วย HTML ที่เขียนเอง', description: '' },
    },
    textConfigs: {
      landingTextDocumentUrlTH: { value: '', label: 'ลิ้งค์สำหรับ Download เอกสาร (ไทย)', description: 'ถ้าไม่ระบุ จะใช้การ Download ไฟล์เริ่มต้นของระบบ' },
      landingTextDocumentUrlEN: { value: '', label: 'ลิ้งค์สำหรับ Download เอกสาร (Eng)', description: 'ถ้าไม่ระบุ จะใช้การ Download ไฟล์เริ่มต้นของระบบ' },
      landingWatchNowText: { value: '', label: 'ข้อความแสดงบน Live Now', description: 'ถ้าไม่ระบุ จะแสดงเป็นข้อความเปล่า' },
      landingTextDocumentButton: { value: '', label: 'ข้อความแสดงบนปุ่มดาวน์โหลดเอกสาร', description: 'ค่าเริ่มต้นจะเป็น Document' },
      landingTextContactEmail: { value: '', label: 'อีเมลสำหรับติดต่อ', description: 'อีเมล' },
      landingTextContactPhone: { value: '', label: 'เบอร์ติดต่อ โทรศัพท์', description: 'ระบุเบอร์โทรศัพท์' },
      landingTextCountdown: {
        value: NOW, label: 'วัน-เวลา สำหรับนับถอยหลัง', description: '', type: 'date-time',
      },
      landingTextHTML: { value: '', label: 'HTML', description: '' },
    },
    images: {
      landingPageKeyVisualImageTH: { value: '', label: 'อัปโหลด Key Visual (ไทย)', description: 'ภาพตัวอย่าง Key Visual (ไทย)' },
      landingPageKeyVisualImageEN: { value: '', label: 'อัปโหลด Key Visual (Eng)', description: 'ภาพตัวอย่าง Key Visual (Eng)' },
      landingPageOverviewImageTH: { value: '', label: 'อัปโหลดรูป Overview (ไทย)', description: 'ภาพตัวอย่าง Overview (ไทย)' },
      landingPageOverviewImageEN: { value: '', label: 'อัปโหลดรูป Overview (Eng)', description: 'ภาพตัวอย่าง Overview (Eng)' },
      landingPageAgendaImageTH: { value: '', label: 'อัปโหลดรูป Agenda (ไทย)', description: 'ภาพตัวอย่าง Agenda (ไทย)' },
      landingPageAgendaImageEN: { value: '', label: 'อัปโหลดรูป Agenda (Eng)', description: 'ภาพตัวอย่าง Agenda (Eng)' },
      landingPageBackgroundImage: { value: '', label: 'อัปโหลดรูปพื้นหลัง', description: 'ภาพพื้นหลังหน้า Landing' },
    },
  },
  live: {
    features: {
      liveEnableTitleTop: { value: false, label: 'แสดงชื่องานด้านบน' },
    },
    textConfigs: {
      liveTextUpperBannerUrl: { value: '', label: 'ลิ้งค์สำหรับ Banner ด้านบน', description: 'ถ้าไม่ระบุจะไม่สามารถกด Banner ได้' },
      liveTextBelowBannerUrl: { value: '', label: 'ลิ้งค์สำหรับ Banner ด้านล่าง', description: 'ถ้าไม่ระบุจะไม่สามารถกด Banner ได้' },
    },
    images: {
      liveImageUpperVideoTH: { value: '', label: 'รูปสำหรับแสดงด้านบน Video (ไทย)', description: 'ภาพตัวอย่าง' },
      liveImageUpperVideoEN: { value: '', label: 'รูปสำหรับแสดงด้านบน Video (Eng)', description: 'ภาพตัวอย่าง' },
      liveImageBelowVideoTH: { value: '', label: 'รูปสำหรับแสดงด้านล่าง Video (ไทย)', description: 'ภาพตัวอย่าง' },
      liveImageBelowVideoEN: { value: '', label: 'รูปสำหรับแสดงด้านล่าง Video (Eng)', description: 'ภาพตัวอย่าง' },
    },
  },
  meta: {
    features: {},
    textConfigs: {
      metaTextTitle: { value: '', label: 'Title', description: 'ชื่อ Title' },
      metaTextDescription: { value: '', label: 'Description', description: 'คำอธิบาย' },
      // metaTextCanonical: { value: '', label: 'Canonical', description: 'ลิ้งค์' },
    },
    images: {
      metaImage: { value: '', label: 'อัปโหลดรูป ที่แสดงเวลาแชร์ข้อมูล', description: 'ภาพตัวอย่าง' },
      metaImageFavIcon: { value: '', label: 'อัปโหลดรูป Fav Icon', description: 'ภาพตัวอย่าง' },
    },
  },
};

const assignConfigToModule = async (key: string, moduleName: string, value: any) => {
  if (key.indexOf('Image') > -1) {
    ((baseConfig as any)[moduleName as string].images as any)[key].value = value;
  } else if (key.indexOf('Text') > 0) {
    ((baseConfig as any)[moduleName as string].textConfigs as any)[key].value = value;
  } else if (key.indexOf('Enable') > 0) {
    ((baseConfig as any)[moduleName as string].features as any)[key].value = (value === '1');
  }
};
const assignConfigToVariable = async ([key, value]: any[]) => {
  if (key.indexOf('login') === 0) await assignConfigToModule(key, 'login', value);
  else if (key.indexOf('register') === 0) await assignConfigToModule(key, 'register', value);
  else if (key.indexOf('website') === 0) await assignConfigToModule(key, 'website', value);
  else if (key.indexOf('landing') === 0) await assignConfigToModule(key, 'landing', value);
  else if (key.indexOf('live') === 0) await assignConfigToModule(key, 'live', value);
  else if (key.indexOf('meta') === 0) await assignConfigToModule(key, 'meta', value);
  else if (key === 'color-primary') baseConfig.colors[0] = { key: 'primary', colorCode: value };
  else if (key === 'color-secondary') baseConfig.colors[1] = { key: 'secondary', colorCode: value };
};

const isEmptyObject = (obj: any) => Object.keys(obj).length === 0 && obj.constructor === Object;
const returnForGetConfigs = (moduleName: string) => {
  if (moduleName === 'color') return (baseConfig as any).colors;
  if (moduleName === 'all') return (baseConfig as any);
  return {
    features: isEmptyObject((baseConfig as any)[moduleName].features) ? null : (baseConfig as any)[moduleName].features,
    textConfigs: isEmptyObject((baseConfig as any)[moduleName].textConfigs) ? null : (baseConfig as any)[moduleName].textConfigs,
    images: isEmptyObject((baseConfig as any)[moduleName].images) ? null : (baseConfig as any)[moduleName].images,
  };
};

export default function siteConfig(axios: any) {
  const getConfigs = async (moduleName: string, force = false) => {
    if (baseConfig.hasRan && !force) {
      return returnForGetConfigs(moduleName);
    }

    const result = await axios.get('/site');
    try {
      if (result.status === 200) {
        await Object.entries(result.data.data).forEach(assignConfigToVariable);
        return returnForGetConfigs(moduleName);
      }
    } catch (error) {
      console.error('[/api/index.ts] getConfigs error');
    }
    return '';
  };

  const updateWebsiteConfig = async (
    configs: any,
    moduleName: string,
  ) => {
    const result = await axios.post('/site/edit', configs);

    try {
      if (result.status === 200) {
        await Object.entries(result.data).forEach(assignConfigToVariable);
        return returnForGetConfigs(moduleName);
      }
    } catch (error) {
      console.error('[/api/index.ts] updatedWebsiteConfig error');
    }
    return '';
  };

  const deleteFileConfig = async (
    key: any,
    moduleName: string,
  ) => {
    const result = await axios.post('/site/delete', { key });

    try {
      if (result.status === 200) {
        await assignConfigToVariable([key, '']);
        return returnForGetConfigs(moduleName);
      }
    } catch (error) {
      console.error('[/api/index.ts] deleteFileConfig error');
    }
    return '';
  };

  return {
    getConfigs,
    updateWebsiteConfig,
    deleteFileConfig,
  };
}
